import { colors } from '@lmc/common/constants'
import type React from 'react'
import { ProfilePicture } from '../../../generic'

interface Resident {
  name: {
    first: string
    last: string
  }
  picture: string
  // Add other properties as needed
}

interface EmarMedicationResidentInfoProps {
  resident: Resident
  testId?: string
}

const EmarMedicationResidentInfo: React.FC<EmarMedicationResidentInfoProps> = (
  props
) => {
  const { resident, testId } = props
  return (
    <div
      style={styles.residentInfoContainer}
      data-testid={testId ? `${testId}-resident-info` : 'resident-info'}
    >
      <div style={styles.residentPhoto}>
        <ProfilePicture size={36} url={resident?.picture} />
      </div>
      <div style={styles.residentNameContainer}>
        <h3 style={styles.residentName}>
          {`${resident?.name?.first} ${resident?.name?.last}`}
        </h3>
        <div style={styles.residentNameUnderline} />
      </div>
    </div>
  )
}

const styles = {
  residentInfoContainer: {
    display: 'flex',
    width: '100%'
  },
  residentName: {
    fontWeight: 400,
    fontSize: 20,
    lineHeight: '30px',
    marginBottom: 3
  },
  residentNameContainer: {
    alignSelf: 'flex-end',
    flexGrow: 1
  },
  residentNameUnderline: {
    border: `1px solid ${colors.grey}`
  },
  residentPhoto: {
    marginRight: 16
  }
}

export default EmarMedicationResidentInfo
